import React, { useEffect } from 'react';
import { Field, reduxForm, getFormValues } from 'redux-form';
import { Button } from 'reactstrap';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import renderField from '../../../shared/components/custom/Field';
import NewspaperIcon from 'mdi-react/NewspaperIcon';
import PlayBoxOutlineIcon from 'mdi-react/PlayBoxOutlineIcon';
import FormCard from '../../../shared/components/custom/FormCard';
import ChoiceCards from '../../../shared/components/custom/ChoiceCards';
import SwitchRow from '../../../shared/components/custom/SwitchRow';
import validate from './validateNewsCategory';
import t, { partial } from '../../../util/translation/translation';

const NewsCategoryForm = ({
  handleSubmit,
  category,
  categories,
  initialize,
}) => {
  const s = partial('shared');
  const c = partial('NewsCategory');
  const typeOptions = [
    {
      value: 'news',
      icon: NewspaperIcon,
      label: c('type-news'),
      hint: c('typeNewsHint'),
    },
    {
      value: 'video',
      icon: PlayBoxOutlineIcon,
      label: c('type-video'),
      hint: c('typeVideoHint'),
    },
  ];
  useEffect(() => {
    // A new category is a news category shown in the app
    initialize({
      name: category?.name || '',
      type: category?.type || 'news',
      hidden: !!category?.hidden,
    });
    // initialize is a stable redux-form dispatch; omitted to avoid re-running
    // on every render since it doesn't change identity meaningfully here.
    // eslint-disable-next-line
  }, [category]);
  return (
    <form onSubmit={handleSubmit} className="form settings-form">
      <div className="user-layout">
        <FormCard title={s('newsCategory')}>
          <p className="user-form__hint">{t('NewsForm.categoryHint')}</p>
          <div className="form__form-group mb-0">
            <span className="form-header">
              {t('product&CategoryShare.categoryName')}
            </span>
            <Field
              name="name"
              component={renderField}
              placeholder={t('product&CategoryShare.categoryName')}
            />
          </div>
          <div className="form__form-group mt-3">
            <span className="form-header">{c('showOn')}</span>
            <Field
              name="type"
              component={ChoiceCards}
              options={typeOptions}
              ariaLabel={c('showOn')}
            />
          </div>
          <Field
            name="hidden"
            component={SwitchRow}
            label={c('hideInApp')}
            description={c('hideInAppHint')}
          />
        </FormCard>
        <FormCard
          title={
            <>
              {t('NewsForm.allCategories')}
              <span className="form-card__count">{categories.length}</span>
            </>
          }
          bodyClassName="form-card__body--flush"
        >
          {categories.length ? (
            <ol className="settings-side-list">
              {categories.map((item) => (
                <li
                  key={item.id}
                  className={
                    item.id === category?.id
                      ? 'settings-side-list__item--current'
                      : ''
                  }
                >
                  <span>{item.name}</span>
                  {item.type === 'video' && (
                    <span className="settings-side-list__meta">
                      {c('type-video')}
                    </span>
                  )}
                </li>
              ))}
            </ol>
          ) : (
            <p className="settings-side-list__empty">{s('noCategories')}</p>
          )}
        </FormCard>
      </div>
      <div className="messages-form__footer">
        <span />
        <div className="messages-form__secondary">
          <Link
            to="/news?tab=2"
            className="btn btn-outline-secondary btn-sm mb-0"
          >
            {s('close')}
          </Link>
          <Button type="submit" color="primary" size="sm" className="mb-0">
            {category ? s('save') : s('create')}
          </Button>
        </div>
      </div>
    </form>
  );
};

NewsCategoryForm.defaultProps = {
  categories: [],
};

const reduxF = reduxForm({
  form: 'news_category_form',
  validate,
});

export default withRouter(
  connect((state) => ({
    formValues: getFormValues('news_category_form')(state),
  }))(reduxF(NewsCategoryForm))
);
